import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getdataByIdim_participant = (id) => {
  return httpClientImmigration.get(server.IM_PARTICIPANT + `/getbyid/${id}`);
};

export const getAllim_participant_Company = (query) => {
  return httpClientImmigration.get(
    server.IM_PARTICIPANT + `/getAllim_participant_Company`,
    query,
  );
};

export const addim_participant = (data) => {
  return httpClientImmigration.post(server.IM_PARTICIPANT + `/`, data);
};

export const updateim_participant = (id, data) => {
  return httpClientImmigration.put(server.IM_PRINCIPAL + `/${id}`, data);
};

export const deleteim_participant = (id) => {
  return httpClientImmigration.delete(server.IM_PARTICIPANT + `/${id}`);
};
